module.exports = __webpack_public_path__ + "assets/images_base/st-button-facebook.svg?v=18ad7547";